<template>
	<div class="orders-reviews-container">
		<ModalHeader :title="getString('reviews_comments')" />
		
		<div class="comments-container row flex-start" v-if="analyticsStore.ordersReviews.length > 0">
			<template v-for="review in analyticsStore.ordersReviews" :key="review.feedback_id">
				<CommentCloud 
					:order="review.order" 
					v-if="review.order" />
				<CommentCloud 
					:feedback="review" 
					without-order 
					v-if="!review.order" />
			</template>
		</div>
		
		<div class="no-reviews" v-else-if="!loading">
			{{ getString("no_reviews_found") }}
		</div>
		
		<div class="load-more-container" v-if="analyticsStore.ordersReviewsPagination.hasMore && !loading">
			<AppButton @click="loadMore" :text="getString('load_more')" outline></AppButton>
		</div>
		
		<AppLoader v-if="loading" class="loader" :size="40" />
	</div>
</template>

<script>
import { useAnalyticsStore } from "@/console-new/stores";
import { useLanguageStore } from "@/shared/stores";
import CommentCloud from "@/console-new/components/analytics/CommentCloud.vue";
import AppButton from "@/shared/components/AppButton.vue";
import AppLoader from "@/shared/components/AppLoader.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import { formatDateTimeWithSeconds } from "@/shared/helpers/dates";

export default {
	setup() {
		const analyticsStore = useAnalyticsStore();
		const languageStore = useLanguageStore();
		return { analyticsStore, getString: languageStore.getString };
	},
	name: "OrdersReviews",
	components: { CommentCloud, AppButton, AppLoader, ModalHeader },
	props: {
		dates: {
			type: Object,
			required: true,
			validator: (value) => {
				return value.hasOwnProperty("start") && value.hasOwnProperty("end");
			}
		}
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		loadReviews(page = 1) {
			this.loading = true;
			const startDate = formatDateTimeWithSeconds(this.dates.start);
			const endDate = formatDateTimeWithSeconds(this.dates.end);
			
			this.analyticsStore.getOrdersReviews(startDate, endDate, page, () => {
				this.loading = false;
			});
		},
		loadMore() {
			const nextPage = this.analyticsStore.ordersReviewsPagination.page + 1;
			this.loadReviews(nextPage);
		}
	},
	mounted() {
		this.loadReviews();
	},
	watch: {
		dates: {
			handler() {
				this.analyticsStore.ordersReviews = [];
				this.analyticsStore.ordersReviewsPagination = { page: 1, hasMore: true, total: 0 };
				this.loadReviews();
			},
			deep: true
		}
	}
};
</script>

<style lang="scss" scoped>
.orders-reviews-container {
	height: 100%;
	overflow-y: auto;
	
	
	.comments-container {
		--item-gap: 15px;
		--num-items: 4;
		gap: var(--item-gap);

		.comment-container {
			width: calc(
				(100% - (var(--num-items) - 1) * var(--item-gap))
				/ var(--num-items)
			);

			@media (max-width: 1440px) {
				--num-items: 3;
			}

			@media (max-width: 820px) {
				--num-items: 2;
			}

			@media (max-width: 460px) {
				--num-items: 1;
				margin: 0 auto;
			}
		}
	}
	
	.no-reviews {
		text-align: center;
		padding: 40px;
		color: var(--color-txt-2);
		font-size: 16px;
	}
	
	.load-more-container {
		display: flex;
		justify-content: center;
		padding: 20px 0;
	}
	
	.loader {
		display: flex;
		justify-content: center;
		padding: 40px;
	}
}
</style>